import React from "react";
import BaseComponentInternas from "../../Components/BaseComponentInternas";
import MeAjudaComponent from "../../Components/MeAjuda";

const MeAjuda = () => {
  return (
    <BaseComponentInternas overflow="hidden">
      <MeAjudaComponent />
    </BaseComponentInternas>
  );
};

export default MeAjuda;
